import { Data } from "../../types"
import { Flex } from "../../../Flex"
import { Box } from "../../../Box"
import { Text } from "../../../Typography"
import { CircleMarker } from "./CircleMarker"
import * as styles from "./legendStyles"

const LegendMarker = <TData = unknown, TLabel = unknown>({
  icon,
  color,
}: Pick<Data<TData, TLabel>, "color" | "icon">) => {
  if (icon) return <Box>{icon}</Box>
  return <CircleMarker color={color} />
}

export const LegendItem = <TData = unknown, TLabel = unknown>({
  label,
  value,
  percentage,
  color,
  icon,
}: Data<TData, TLabel>) => (
  <Flex alignItems="center" css={styles.legend}>
    <LegendMarker icon={icon} color={color} />
    <ul>
      <Text tag="li">{label}</Text>
      <Text tag="li" css={styles.bold}>
        {value}
      </Text>
      {percentage != null && <Text tag="li" css={styles.bold}>{`${percentage}%`}</Text>}
    </ul>
  </Flex>
)

LegendItem.defaultProps = {
  total: undefined,
}
